import { skipToken, useQuery } from "@tanstack/react-query";
import { getPartiesPublicID } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

export const PARTY_QUERY_KEY = "PARTY";

export const getPartyQueryKey = (publicID?: string | null) => [
  PARTY_QUERY_KEY,
  publicID,
];

export const EMPTY_GUID = "00000000-0000-0000-0000-000000000000";

export const usePartyQuery = (publicID?: string | null) =>
  useQuery({
    queryKey: getPartyQueryKey(publicID),
    queryFn:
      !!publicID && publicID !== EMPTY_GUID
        ? processResponseWithApiProblemDetails(() =>
            getPartiesPublicID(publicID),
          )
        : skipToken,
    refetchOnWindowFocus: false,
  });
